/* eslint-disable */
import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import Header from "./Header/index.jsx";
import Footer from "./Footer/index.jsx";
import Sidebar from "./Sidebar/index.jsx";

import authRoutes from "./auth.jsx";
import { ToastNotify } from "interface/components";
import {
  LoadingComponent,
  SpinnerComponent,
} from "../../../components/index.js";
import { HOME_PAGE } from "config.js";

const AuthLayout = () => {
  const [allDone, setAllDone] = useState(false);
  const general = useSelector((state) => state.General);
  const location = useLocation();

  useEffect(() => {
    setAllDone(true);
  }, [general]);

  if (
    location.pathname !== "/" &&
    location.pathname !== "/home" &&
    location.pathname !== "/oauth" &&
    location.pathname !== "/register" &&
    location.pathname !== "/about" &&
    !location.pathname.includes("/sso/vneid/signin") &&
    !location.pathname.includes("/vneid-login")
  ) {
    if (!sessionStorage.getItem("redirectAfterLogin")) {
      sessionStorage.setItem(
        "redirectAfterLogin",
        location.pathname + location.search
      );
    }
  }

  if (!allDone) {
    return <LoadingComponent />;
  }

  const switchRoutes = (
    <Routes>
      {authRoutes.map((prop, key) => (
        <Route
          key={key}
          path={prop.path}
          element={
            prop.redirect ? (
              <Navigate from={prop.path} to={prop.to} key={key} />
            ) : (
              <Suspense fallback={<LoadingComponent />}>
                {prop.component}
              </Suspense>
            )
          }
        />
      ))}
    </Routes>
  );

  // return (
  //   <>
  //     {switchRoutes}
  //     <ToastNotify />
  //   </>
  // );

  if (location.pathname.includes("/vneid-login")) {
    return (
      <React.Fragment>
        {switchRoutes}
        <ToastNotify />
        <SpinnerComponent />
      </React.Fragment>
    );
  }

  const divStyle = {
    backgroundImage: `url(${require("common/assets/imgs/BG.png")})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <React.Fragment>
      <div className="application" style={divStyle}>
        <div className="application-container-web">
          {/* <Header /> */}
          {/* <Sidebar location={location} />  */}
          <main className="main-layout">
            <div className="container main-layout-container">
              {switchRoutes}
            </div>
            <SpinnerComponent />
          </main>
          <Footer />
        </div>
      </div>
      <ToastNotify />
    </React.Fragment>
  );
};

export default AuthLayout;
